// extracted by mini-css-extract-plugin
export var allEvents = "agenda-module--all-events--30bfd";
export var editButtonTitle = "agenda-module--edit-button-title--8c530";
export var eventsContainer = "agenda-module--events-container--edf3c";
export var eventsDescription = "agenda-module--events-description--0572e";
export var eventsItem = "agenda-module--events-item--2f94d";
export var eventsItemDate = "agenda-module--events-item-date--2a8d0";
export var eventsItemDateFrom = "agenda-module--events-item-date-from--20631";
export var eventsItemDateTo = "agenda-module--events-item-date-to--f722c";
export var eventsItemImg = "agenda-module--events-item-img--4bd13";
export var eventsItemRecurrence = "agenda-module--events-item-recurrence--d9272";
export var eventsItemTaxo = "agenda-module--events-item-taxo--13c58";
export var eventsItemTitle = "agenda-module--events-item-title--3e5a7";
export var listEventsContainer = "agenda-module--list-events-container--bbfaf";
export var listEventsTitle = "agenda-module--list-events-title--d12eb";